import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver } from 'react-hook-form';

import { FormValues } from './FormValues';
import { schema } from './schema';

export const resolver: Resolver<FormValues> = zodResolver(schema);
